<!--
 * @Author: your name
 * @Date: 2021-01-04 19:58:41
 * @LastEditTime: 2021-01-05 00:56:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/components/Recommend/index.vue
-->
<template>
  <div>
    <!-- <van-pull-refresh v-model="loading"> -->
    <van-list
      v-model="loading"
      :finished="!productCon.hasNextPage"
      finished-text="我已经到底啦～"
      @load="onLoad"
    >
      <div class="product_list">
        <div
          v-for="(i, index) in productCon.rows"
          :key="index"
          :class="{ item_left: index % 2 !== 0 }"
          class="product"
        >
          <product-ver-com :product="i" @showPoster="showPoster" />
        </div>
      </div>
    </van-list>
    <!-- </van-pull-refresh> -->
  </div>
</template>

<script>
const ProductVerCom = () =>
  import("@/components/ProductVerCom").then(m => m.default || m);
export default {
  props: {
    // productList: {
    //   type: Array,
    //   default() {
    //     return [];
    //   }
    // },
    productCon: {
      type: Object,
      default() {
        return {};
      }
    },
    loadings: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    loading: {
      get() {
        return this.loadings;
      },
      set(s) {
        this.$emit("update:loadings", s);
      }
    }
  },
  components: {
    ProductVerCom
  },
  data() {
    return {
      // loading: false
    };
  },
  methods: {
    onLoad() {
      // console.log("调用底部上拉数据");
      this.$emit("onLoad");
    },
    showPoster(product) {
      this.$emit("showPoster", product);
    }
  }
};
</script>
<style lang="less" scoped>
.product_list {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-left: 12px;
  padding-right: 12px;
  box-sizing: border-box;
  .item_left {
    margin-left: 10px;
  }
}
</style>
